/*
 * Explore-Button Controller Start.
 */
var ExploreButtonController = (function ($) {

    var topexplorebutton, bottomexplorebutton, topsocial,  bottomsocial;

    topexplorebutton = $("#main a.article-explore-button"); 
    bottomexplorebutton = $("#root > div.clear > a.article-explore-button");
    topsocial = $("#main div.article-byline div.newsroom-social");
    bottomsocial = $("#root > div.newsroom-social");

    function ready() {
        moveExploreButton();
    }

    function moveExploreButton() {
        if (BreakpointController.isMobile() ) {
            if (topsocial.length === 1 && topexplorebutton.length === 1) {
                topsocial.prepend(topexplorebutton);
            }

            if (bottomsocial.length === 1 && bottomexplorebutton.length === 1) {
                bottomsocial.prepend(bottomexplorebutton);
            }
            
           
        }
    }

    $(ready);
    return;

})(jQuery);

/*
 * Explore-Button Controller End.
 */